import { render, staticRenderFns } from "./LoadProfile.vue?vue&type=template&id=8337dd06&"
import script from "./LoadProfile.vue?vue&type=script&lang=js&"
export * from "./LoadProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports